import { SectionCard } from "@/components/shared/PageChrome";
import { statusLabel } from "@/components/shared/StatusBadge";

// Labels for the server's CLIENT_PUBLIC_EVENTS allowlist only; anything else the server would not send.
const LABELS = {
  "enquiry.created": "Request submitted",
  "enquiry.assigned": "Jigsaw coordinator assigned",
  "enquiry.status_changed": "Status updated",
  "client_offer.presented": "Offer presented to you",
  "client_offer.decided": "Decision recorded",
  "enquiry.completed": "Booking confirmed",
};

const DOT = { "enquiry.completed": "bg-jigsaw-success", "client_offer.decided": "bg-jigsaw-navy", "enquiry.created": "bg-jigsaw-navy" };

const fmt = (iso) => new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

function describe(ev, offersById, coordinator) {
  const m = ev.metadata || {};
  const offer = m.client_offer_id ? offersById[m.client_offer_id] : null;
  const who = offer ? `${offer.supplier_name}${offer.property_name ? ` · ${offer.property_name}` : ""}` : null;
  switch (ev.action) {
    case "enquiry.assigned": return coordinator ? `Handled by ${coordinator}` : null;
    case "enquiry.status_changed": return m.to ? `Now ${statusLabel(m.to).toLowerCase()}` : null;
    case "client_offer.presented": return who;
    case "client_offer.decided": {
      const by = offer?.decided_by === "JIGSAW" ? " · recorded by Jigsaw on your behalf" : offer?.decided_by === "CLIENT" ? " · your decision" : "";
      return `${m.decision ? statusLabel(m.decision) : "Decision"}${who ? ` — ${who}` : ""}${by}`;
    }
    case "enquiry.completed": return m.booking_reference ? `Booking reference ${m.booking_reference}` : null;
    default: return null;
  }
}

export function ClientTimeline({ events = [], offers = [], coordinator }) {
  const offersById = Object.fromEntries(offers.map((o) => [o.id, o]));
  return (
    <SectionCard title="Event timeline" testId="client-request-timeline" bodyClassName="px-5 pb-4" subtitle="Events recorded on this request">
      {events.length === 0 ? <p data-testid="client-timeline-empty" className="text-sm text-jigsaw-muted">No events recorded yet.</p> : (
        <ol className="space-y-4">
          {events.map((ev) => {
            const desc = describe(ev, offersById, coordinator);
            return (
              <li key={ev.id} data-testid={`timeline-event-${ev.id}`} data-action={ev.action} className="flex gap-3">
                <span className={`mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full ${DOT[ev.action] || "bg-jigsaw-orange"}`} />
                <div className="min-w-0 flex-1">
                  <div className="flex items-baseline justify-between gap-3">
                    <p className="text-[13px] font-semibold text-jigsaw-navy">{LABELS[ev.action] || ev.action.replace(/[._]/g, " ")}</p>
                    <time dateTime={ev.created_at} className="font-mono-ref shrink-0 text-[11px] text-jigsaw-muted">{fmt(ev.created_at)}</time>
                  </div>
                  {desc && <p className="mt-0.5 text-[13px] leading-snug text-jigsaw-muted">{desc}</p>}
                </div>
              </li>
            );
          })}
        </ol>
      )}
    </SectionCard>
  );
}
